import { render } from "./MemberTop.vue?vue&type=template&id=83b0fbcc&scoped=true"
import script from "./MemberTop.vue?vue&type=script&lang=js"
export * from "./MemberTop.vue?vue&type=script&lang=js"

import "./MemberTop.vue?vue&type=style&index=0&id=83b0fbcc&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b0fbcc"]])

export default __exports__